import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { Link } from "react-router-dom";
import { typeBadge } from "@/lib/ticketTypes";

const DRINK_LABEL = { SOFT_DRINK: "Soft Drink", BEER: "Beer", COCKTAIL: "Cocktail" };

export default function RedemptionHistory() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/redemptions", { params: { limit: 500 } }).then((r) => setItems(r.data.items)); }, []);

  return (
    <div className="space-y-6">
      <div>
        <div className="text-xs tracking-[0.3em] uppercase text-orange-400 font-bold">Live</div>
        <h1 className="font-display text-4xl sm:text-5xl font-black text-white tracking-tight">REDEMPTION HISTORY</h1>
      </div>
      <div className="bg-[#131D33] border border-slate-800 rounded-2xl overflow-hidden">
        <div className="hidden md:grid grid-cols-12 px-4 py-3 text-xs uppercase tracking-widest text-slate-400 border-b border-slate-800 bg-black/20">
          <div className="col-span-2">Time</div>
          <div className="col-span-2">Ticket</div>
          <div className="col-span-2">Type</div>
          <div className="col-span-2">Drink Served</div>
          <div className="col-span-3">Bartender</div>
          <div className="col-span-1 text-right">New Bal.</div>
        </div>
        <div className="divide-y divide-slate-800">
          {items.length === 0 && <div className="p-10 text-center text-slate-500">No redemptions yet.</div>}
          {items.map((r) => (
            <Link to={`/tickets/${r.ticket_id}`} key={r.id} className="grid grid-cols-2 md:grid-cols-12 px-4 py-3 hover:bg-white/5" data-testid={`redemption-${r.id}`}>
              <div className="md:col-span-2 text-slate-400 text-sm">{new Date(r.at).toLocaleTimeString()}</div>
              <div className="md:col-span-2 font-mono-fb text-orange-300">{r.ticket_visible}</div>
              <div className="md:col-span-2">
                <span className={`inline-block px-2 py-0.5 text-xs font-bold rounded ${typeBadge(r.ticket_type)}`}>{r.ticket_type}</span>
              </div>
              <div className="md:col-span-2 text-white font-semibold">{DRINK_LABEL[r.drink_type] || "—"}{r.credit_source === "ADDITIONAL_PURCHASED" && <span className="ml-2 text-[10px] px-1.5 py-0.5 rounded bg-orange-500/20 text-orange-300 font-bold tracking-widest uppercase">+Purchased</span>}</div>
              <div className="md:col-span-3 text-slate-400 text-sm truncate">{r.staff_email}</div>
              <div className="md:col-span-1 text-right font-bold text-emerald-400">{r.new_balance}</div>
            </Link>
          ))}
        </div>
      </div>
    </div>
  );
}
